export const actionTypes = {
  REQUEST_OFFER_DETAILS: 'REQUEST_OFFER_DETAILS',
  SUCCESS_OFFER_DETAILS: 'SUCCESS_OFFER_DETAILS',
  ERROR_OFFER_DETAILS: 'ERROR_OFFER_DETAILS',

  REQUEST_ORDER_PRODUCT: 'REQUEST_ORDER_PRODUCT',
  SUCCESS_ORDER_PRODUCT: 'SUCCESS_ORDER_PRODUCT',
  ERROR_ORDER_PRODUCT: 'ERROR_ORDER_PRODUCT'
}